import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider
} from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      maxWidth: 800,
      mx: 'auto',
      p: 3
    }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4,
          borderRadius: 2,
          textAlign: 'center'
        }}
      >
        <Box sx={{ mb: 4 }}>
          <CancelOutlinedIcon 
            color="warning" 
            sx={{ fontSize: 80 }} 
          />
          
          <Typography variant="h4" sx={{ mt: 2, fontWeight: 'medium' }}>
            Subscription Cancelled
          </Typography>
          
          <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
            Your subscription process was cancelled and no payment has been processed.
          </Typography>
        </Box>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1">
            If you experienced any issues during the checkout process, 
            please don't hesitate to contact our support team for assistance.
          </Typography>
        </Box>
        
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button 
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/subscription')}
          >
            Back to Plans
          </Button>
          
          <Button 
            variant="contained" 
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SubscriptionCancel;